/**
 * Notifications & Custom Dialogs Module (Bridge)
 * This module is kept for backward compatibility.
 * It dispatches events that are caught by ToastContext.tsx
 */

export const TOAST_EVENT = 'app-toast';
export const CONFIRM_EVENT = 'app-confirm';

/**
 * Show a toast notification
 * @param {string} message 
 * @param {string} type - 'success', 'error', 'info', 'warning'
 */
export function showToast(message: string, type: 'success' | 'error' | 'warning' | 'info' | 'progress' = 'info', duration?: number) {
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, { 
        detail: { message, type, duration } 
    }));
}

/**
 * Promise-based custom confirmation dialog
 * @param {string} message 
 * @param {string} confirmText 
 * @param {string} cancelText 
 * @returns {Promise<boolean>}
 */
export function confirmDialog(message: string, confirmText = 'Confirm', cancelText = 'Cancel'): Promise<boolean> {
    return new Promise((resolve) => {
        window.dispatchEvent(new CustomEvent(CONFIRM_EVENT, { 
            detail: { message, confirmText, cancelText, resolve } 
        }));
    });
}














